/**
 * Decide whether a chat stream (SSE) failure should be reported to Sentry.
 *
 * The chat stream surfaces two very different kinds of failure through the same
 * `error` event:
 *   - The server responded with an HTTP error status (>= 400) — a real,
 *     actionable problem we want in Sentry.
 *   - The transport dropped before any HTTP status was seen (status 0 /
 *     undefined / NaN): the client lost the connection, the user navigated
 *     away, or a mobile network blip aborted a large upload. These are benign
 *     client-side network events, not bugs.
 *
 * Reporting the latter floods Sentry — it inflated the `chat_sse_error` issue
 * to 138 users (CHAT-MARITACA-25) and, because handled errors are fingerprinted
 * by feature+category, buried the genuine 5xx stream failures in the same
 * group. Only failures carrying a real HTTP error status are worth reporting.
 */
export function shouldReportSseError(status: unknown): boolean {
  return typeof status === 'number' && Number.isFinite(status) && status >= 400;
}
